import { atom, useAtomValue } from 'jotai'
import type { ReserveInputPlan, ReserveInputReserveInfo } from './stateMachine/state'
import { plan$, reserveInfo$ } from './stateMachine/state'

const showTimeSaleText$ = atom((get) => {
  const reserveInfo = get(reserveInfo$)
  return showTimeSaleText(reserveInfo)
})
showTimeSaleText$.debugLabel = 'showTimeSaleText$'

function showTimeSaleText(reserveInfo: ReserveInputReserveInfo | undefined) {
  // discountRatePercent が null または undefined の場合は、0 として扱う
  const discountRatePercent = reserveInfo?.inventory.discountRatePercent ?? 0
  return discountRatePercent > 0
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('showTimeSaleText', () => {
    expect(showTimeSaleText(undefined)).toBe(false)
    expect(
      showTimeSaleText({ inventory: { discountRatePercent: null } } as ReserveInputReserveInfo)
    ).toBe(false)
    expect(
      showTimeSaleText({ inventory: { discountRatePercent: 0 } } as ReserveInputReserveInfo)
    ).toBe(false)
    expect(
      showTimeSaleText({ inventory: { discountRatePercent: 1 } } as ReserveInputReserveInfo)
    ).toBe(true)
  })
}

export function useShowTimeSaleText() {
  return useAtomValue(showTimeSaleText$)
}

const isTimeSaleLabelVisible$ = atom((get) => {
  const plan = get(plan$)
  return isTimeSaleLabelVisible(plan)
})
isTimeSaleLabelVisible$.debugLabel = 'isTimeSaleLabelVisible$'

function isTimeSaleLabelVisible(plan: ReserveInputPlan | undefined) {
  // visibleLabel が undefined の場合は、false として扱う
  return plan?.timesale?.visibleLabel ?? false
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('isTimeSaleLabelVisible', () => {
    expect(isTimeSaleLabelVisible(undefined)).toBe(false)
    expect(isTimeSaleLabelVisible({} as ReserveInputPlan)).toBe(false)
    expect(isTimeSaleLabelVisible({ timesale: null } as ReserveInputPlan)).toBe(false)
    expect(isTimeSaleLabelVisible({ timesale: { visibleLabel: false } } as ReserveInputPlan)).toBe(
      false
    )
    expect(isTimeSaleLabelVisible({ timesale: { visibleLabel: true } } as ReserveInputPlan)).toBe(
      true
    )
  })
}

export function useIsTimeSaleLabelVisible() {
  return useAtomValue(isTimeSaleLabelVisible$)
}
